import { useContext, useState } from "react";
import LayoutPropsType from "../types/LayoutPropsType"
import NavbarTwo from "./NavbarTwo";
import { LangContext } from "../App";

const Layout = ({ children } : LayoutPropsType) => {
    const { lang } = useContext(LangContext);

    const [skipMenuToggle, setSkipMenuToggle] = useState<boolean>(false);

    return (
        <div className="layout">
            <div 
                onFocus={() => setSkipMenuToggle(true)}
                onStalled={() => setSkipMenuToggle(false)}
                className={`skip-links-menu ${skipMenuToggle ? "is-visible" : ""}`}
            >
                <div className="wrapper-larg">
                    <div className="skip-menu-container">
                        <span className="skip-link">{lang === 0 ? "Skip to :" : "تخطي إلى :"}</span>
                        <button 
                            className="skip-link"
                            title="Go to navigation menu"
                            aria-label="Navigation menu" 
                            onClick={() => {
                                document.getElementById("homeLink")?.focus();
                                document.getElementById("navbar")?.scrollIntoView();
                            }}
                        >
                            {lang === 0 ? "Navigation menu" : "القائمة الرئيسية"}
                        </button>
                        <button 
                            className="skip-link"
                            title="Go to the main content"
                            aria-label="Skip to main content"  
                            onClick={() => {
                                document.getElementById("mainContent")?.scrollIntoView();
                            }}
                        >
                            {lang === 0 ? "Main content" : "المحتوى الرئيسي"}
                        </button>
                        <button 
                            className="skip-link"
                            aria-label="Skip to Footer" 
                            title="Go to footer"
                            onClick={() => {
                                document.getElementById("footer")?.scrollIntoView();
                            }}
                        >
                            {lang === 0 ? "Footer" : "نهاية الصفحة"}
                        </button>
                    </div>
                </div>
            </div>
            <div id="pageContainer" className="container" onFocus={() => setSkipMenuToggle(false)}>
                {/* <Navbar /> */}
                <NavbarTwo />
                {children}
            </div>
        </div>
    )
}

export default Layout;